import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import ClearIcon from '@mui/icons-material/Clear';


interface Props {
    searchVal : string,
    filterValues: (searchVal : string) => any,
}

const SearchBar: React.FC<Props> = ( { searchVal, filterValues } ) => {
  return (
    <> 
        <div className="entry">
            <TextField
              id="outlines-basic"
              variant="outlined"
              value={searchVal}
              inputProps ={{maxLength: 100}}
              InputProps={{
                  startAdornment: (
                      <InputAdornment position="start">
                          <SearchIcon />
                      </InputAdornment>),
                  endAdornment: (
                      <InputAdornment position="end">
                          <ClearIcon sx={{cursor: 'pointer'}} onClick={() => {
                            filterValues("");
                          }}/>
                      </InputAdornment>
                  ),
              }}
              onChange={(e) => {
                filterValues(e.target.value);
              }}
              />
        </div>
    
    </>
  )
}

export default SearchBar